export default __webpack_public_path__ + "static/media/bg.1689f2fb.webp";